export default __webpack_public_path__ + "static/media/css.bd306463.svg";